export const setToken = (state, payload) => state.token = payload

export const setUser = (state, payload) => state.user = payload

export const setLogin = (state, payload) => state.login = payload

export const resetLogin = (state) => state.login = {}
